import { Box, Checkbox, Typography } from '@mui/material';
import { FC } from 'react';

type DirectorsCheckItemProps = {
    onClick: () => void;
    director: string;
    checked: boolean;
    shareholderPercentage?: number;
};

function formatPercentage(percentage?: number): string {
    if (percentage === undefined || percentage === null || percentage === 0) {
        return '';
    }
    // Format to up to 2 decimal places, removing unnecessary trailing zeros
    return ` ${Number.parseFloat(percentage.toFixed(2))}%`;
}

export const DirectorsCheckItem: FC<DirectorsCheckItemProps> = ({
    onClick,
    director,
    checked,
    shareholderPercentage,
}) => {
    return (
        <Box display="flex" alignItems="center" onClick={onClick}>
            <Checkbox sx={{ color: '#F18F34' }} checked={checked} />
            <Typography color="#1D1D1B" fontSize="14px" lineHeight="21px" fontWeight="700">
                {director}
                {formatPercentage(shareholderPercentage)}
            </Typography>
        </Box>
    );
};
